import axios from "axios";

// Input Search
let inputSearch = document.querySelectorAll(".input input");

// Input default style
Array.from(inputSearch).forEach((e) => {
  // Input state
  e.addEventListener("input", (input) => {
    let inputContainer = input.currentTarget.parentNode.closest(".input");

    if (input.currentTarget.value.length !== 0) {
      inputContainer.classList.add("input--no-empty");
    } else {
      inputContainer.classList.remove("input--no-empty");
    }
  });

  // Focus state
  e.addEventListener("focus", (input) => {
    let inputContainer = input.currentTarget.parentNode.closest(".input");
    inputContainer.classList.add("input--focus");
  });

  // UnFocus state
  e.addEventListener("focusout", (input) => {
    let inputContainer = input.currentTarget.parentNode.closest(".input");
    inputContainer.classList.remove("input--focus");
  });
});

try {
  // Newsletter subscribe
  let formSubscribe = document.querySelector("#form-subscribe");

  formSubscribe.addEventListener("submit", (e) => {
    e.preventDefault();
    let urlAction = e.target.getAttribute("action");
    axios({
      method: "GET",
      url:
        urlAction +
        `?email=${e.target.querySelector("input[type=email]").value}`,
    })
      .then((response) => {
        if (response.status === 200 && response.data.success == "success") {
          document
            .querySelector(".footer__newsletter")
            .insertAdjacentHTML(
              "beforeend",
              `<span class="success">Thank you!</span>`,
            );
          e.target.querySelector("input[type=email#]").value = "";
        }

        if (response.status === 200 && response.data.failed) {
          if (response.data.failed.email) {
            document
              .querySelector(".footer__newsletter")
              .insertAdjacentHTML(
                "beforeend",
                `<span class="error">${response.data.failed.email}</span>`,
              );
          } else {
            document
              .querySelector(".footer__newsletter")
              .insertAdjacentHTML(
                "beforeend",
                `<span class="error">${response.data.failed}</span>`,
              );
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  });
} catch (err) {
  console.log(err);
}
